import { useMemo } from 'react'
import { useAppSelector } from 'hooks/reduxHooks'
import { getCanViewLuxPlusBenefits, getIsLuxPlusEnabled } from 'luxPlus/selectors/featureToggle'
import { getIsLuxPlusToursEnabled } from 'checkout/selectors/tourV2Selectors'
import { isGhaPriceDisplay } from 'selectors/routerSelectors'

interface Options {
  price: number
  memberPrice: number
  offerConfig?: App.OfferLuxPlusConfig
  isTour?: boolean
  mode?: App.LuxPlusPriceStackMode
}

export default function useLuxPlusDisplayedMode({
  price,
  memberPrice,
  offerConfig,
  isTour = false,
  mode,
}: Options): App.LuxPlusPriceStackMode {
  const canViewLuxPlusBenefits = useAppSelector(getCanViewLuxPlusBenefits)
  const luxPlusEnabled = useAppSelector(getIsLuxPlusEnabled)
  const luxPlusTourEnabled = useAppSelector(getIsLuxPlusToursEnabled)
  const isGhaPricing = useAppSelector(isGhaPriceDisplay)

  return useMemo(() => {
    if (!luxPlusEnabled) {
      return 'regular-only'
    } else if (isGhaPricing && memberPrice > 0 && memberPrice < price) {
      return 'regular-prominent'
    } else if (mode) {
      return mode
    } else if (!!isTour && !luxPlusTourEnabled) {
      return 'regular-only'
    } else if (!canViewLuxPlusBenefits && memberPrice > 0 && memberPrice < price) {
      return 'regular-prominent'
    } else if (offerConfig?.access === 'memberOnly') {
      return 'member-only'
    } else if (canViewLuxPlusBenefits && memberPrice > 0 && memberPrice < price) {
      return 'member-prominent'
    } else {
      return 'regular-only'
    }
  }, [canViewLuxPlusBenefits, isTour, offerConfig?.access, luxPlusEnabled, luxPlusTourEnabled, memberPrice, price, mode, isGhaPricing])
}
